import { ResolveFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { SimulationTrackerActions } from 'src/app/state/simulation-tracker/simulation-tracker.actions';
import { forkJoin, from } from 'rxjs';


export const SimulationTrackersResolver: ResolveFn<boolean | null> = () => {
  const store: Store = inject(Store);

  return forkJoin([
    from(store.dispatch(new SimulationTrackerActions.GetSimulationTrackers())),
    from(store.dispatch(new SimulationTrackerActions.GetFavoritedSimulationTrackers()))
  ]).pipe(
    map(() => true)
  );
};
